<template>
  <b-form>
    <div class="list" v-for="(question, index) in listQuestion" :key="question.questionCode">
      <h4
        class="collapsible"
        :class="{
          active: question.isShow,
          error: question.hasError,
          success: checkSuccess(question),
        }"
        @click="question.isShow = !question.isShow"
      >
        {{ `${index + 1}. ${question.questionName}` }}
      </h4>
      <div class="content" :class="{ active: question.isShow }">
        <!--CONDITIONAL_MULTIPLE_CHOICE-->
        <div v-if="question.questionType === EnumQuestionType.CONDITIONAL_MULTIPLE_CHOICE">
          <b-form-group
            label=""
            v-slot="{ ariaDescribedby }"
            class="form-quescard"
            :disabled="disabled"
          >
            <b-form-radio-group
              v-model="question.choice"
              :aria-describedby="ariaDescribedby"
              :name="`CHOICE-YN-${index}`"
              @change="setOnchange"
            >
              <b-form-radio class="mr-3" name="yes-radios" :value="true"> Có </b-form-radio>
              <b-form-radio name="no-radios" :value="false"> Không </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <template v-if="question.choice">
            <b-form-group
              :label="
                question.option?.name
                  ? `${question.option?.name} - (Chọn ít nhất 1 đáp án)`
                  : `(Chọn ít nhất 1 đáp án)`
              "
              v-slot="{ ariaDescribedby }"
              :disabled="disabled"
            >
              <b-form-checkbox-group
                :name="`CHOICE-${index}`"
                v-model="question.optionResult"
                :aria-describedby="ariaDescribedby"
                @change="setOnchange"
              >
                <div v-for="(option, index) in question.option?.optionAnswer" :key="index">
                  <b-form-checkbox v-if="option === 'OTHER'" :value="option">
                    <div class="d-flex w-100" style="gap: 10px">
                      <span>Khác</span>
                      <b-form-input
                        v-show="question?.optionResult?.includes('OTHER')"
                        size="sm"
                        placeholder="Nhập ghi chú, tối đa 255 ký tự"
                        maxlength="255"
                        style="width: 100%"
                        v-model="question.otherAnswerResult"
                        @change="setOnchange"
                      />
                    </div>
                  </b-form-checkbox>
                  <b-form-checkbox v-else :value="option">
                    {{ option }}
                  </b-form-checkbox>
                </div>
              </b-form-checkbox-group>
            </b-form-group>
          </template>
        </div>

        <!--YES_NO_QUESTION-->
        <div v-else-if="question.questionType === EnumQuestionType.YES_NO_QUESTION">
          <b-form-group
            v-slot="{ ariaDescribedby }"
            :name="`YN-${index}`"
            class="form-quescard"
            :disabled="disabled"
          >
            <b-form-radio-group
              v-model="question.choice"
              :aria-describedby="ariaDescribedby"
              @change="setOnchange"
            >
              <b-form-radio class="mr-3" name="yes-radios" :value="true"> Có </b-form-radio>
              <b-form-radio name="no-radios" :value="false">Không</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>

        <!--MULTIPLE_CHOICE-->
        <div v-else-if="question.questionType === EnumQuestionType.MULTIPLE_CHOICE">
          <b-form-group
            :label="question.option?.name"
            v-slot="{ ariaDescribedby }"
            :disabled="disabled"
          >
            <b-form-checkbox-group
              :name="`CHOICE-${index}`"
              v-model="question.optionResult"
              :aria-describedby="ariaDescribedby"
              @change="setOnchange"
            >
              <div v-for="(option, index) in question.option?.optionAnswer" :key="index">
                <b-form-checkbox v-if="option === 'OTHER'" :value="option">
                  <div class="d-flex w-100" style="gap: 10px">
                    <span>Khác</span>
                    <b-form-input
                      v-show="question?.optionResult?.includes('OTHER')"
                      size="sm"
                      placeholder="Nhập ghi chú, tối đa 255 ký tự"
                      maxlength="255"
                      style="width: 100%"
                      v-model="question.otherAnswerResult"
                    />
                  </div>
                </b-form-checkbox>
                <b-form-checkbox v-else :value="option">
                  {{ option }}
                </b-form-checkbox>
              </div>
            </b-form-checkbox-group>
          </b-form-group>
        </div>

        <!--SHORT_ANSWER-->
        <div v-else-if="question.questionType === EnumQuestionType.SHORT_ANSWER">
          <b-form-group v-slot="{ ariaDescribedby }" :disabled="disabled">
            <b-form-textarea
              v-model="question.otherAnswerResult"
              placeholder="Nhập nội dung, tối đa 255 ký tự"
              rows="3"
              max-rows="6"
              :aria-describedby="ariaDescribedby"
              @change="setOnchange"
            />
          </b-form-group>
        </div>

        <!--QUIZ-->
        <div v-else-if="question.questionType === EnumQuestionType.QUIZ">
          <b-form-group :label="question.name" v-slot="{ ariaDescribedby }" :disabled="disabled">
            <b-form-radio-group
              v-model="question.optionResult[0]"
              :options="question.option?.optionAnswer"
              :aria-describedby="ariaDescribedby"
              :name="`QUIZ-${index}`"
              stacked
              @change="setOnchange"
            />
          </b-form-group>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
  import { QuestionList } from '@/services/customer-support/task'
  import { EnumQuestionType } from '@/constant/customerSupport'

  export default {
    name: 'CollectInformation',
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        isLoading: false,
        EnumQuestionType,
        listQuestion: [],
      }
    },
    computed: {
      checkSuccess() {
        return q => {
          switch (q.questionType) {
            case EnumQuestionType.CONDITIONAL_MULTIPLE_CHOICE:
              if (typeof q.choice === 'boolean') {
                if (q.choice) {
                  if (q.optionResult?.length) {
                    return true
                  } else {
                    return false
                  }
                } else {
                  return true
                }
              }
              break
            case EnumQuestionType.MULTIPLE_CHOICE:
              if (q.optionResult?.length) {
                return true
              }
              break
            case EnumQuestionType.YES_NO_QUESTION:
              if (typeof q.choice === 'boolean') {
                return true
              }
              break
            case EnumQuestionType.QUIZ:
              if (q.optionResult?.length) {
                return true
              }
              break
            case EnumQuestionType.SHORT_ANSWER:
              if (q.otherAnswerResult?.trim().length) {
                return true
              }
              break
          }
          return false
        }
      },
    },
    mounted() {
      // this.loadData()
    },
    methods: {
      async setData(collectionData) {
        await this.loadData()
        if (collectionData?.questionList?.length) {
          const mapValue = collectionData.questionList.reduce((map, item) => {
            map[item.questionCode] = item
            return map
          }, {})

          for (const question of this.listQuestion) {
            question.hasError = false
            if (mapValue[question.questionCode]) {
              question.choice = mapValue[question.questionCode].choice
              question.optionResult = mapValue[question.questionCode].optionResult
              question.otherAnswerResult = mapValue[question.questionCode].otherAnswerResult
            }
          }
        }
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await QuestionList()
          this.listQuestion = (res.data?.listData || []).map(question => {
            return {
              ...question,
              isShow: false,
              choice: null,
              optionResult: [],
              otherAnswerResult: '',
              hasError: false,
            }
          })
        } catch (e) {
          this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
        } finally {
          this.isLoading = false
        }
      },

      validate() {
        // const count = this.listQuestion.filter(q => {
        //   const isValid = (() => {
        //     if(typeof q.choice === 'boolean') {
        //       if (q.questionType === 'CONDITIONAL_MULTIPLE_CHOICE') {
        //         const value = q.choice ? q.optionResult?.length > 0 : true
        //         !value && (q.isShow = true)
        //         return value
        //       }
        //       return true
        //     }
        //     return false
        //   })()
        //   || q.optionResult?.length
        //   || q.otherAnswerResult?.trim().length
        //   return isValid
        // }).length
        // return count === 0

        let countError = 0
        let countDone = 0
        for (const q of this.listQuestion) {
          // q.isShow = false;
          q.hasError = false
          switch (q.questionType) {
            case EnumQuestionType.CONDITIONAL_MULTIPLE_CHOICE:
              if (typeof q.choice === 'boolean') {
                if (q.choice) {
                  if (q.optionResult?.length) {
                    countDone++
                  } else {
                    // q.isShow = true;
                    q.hasError = true
                    countError++
                  }
                } else {
                  countDone++
                }
              }
              break
            case EnumQuestionType.MULTIPLE_CHOICE:
              if (q.optionResult?.length) {
                countDone++
              }
              break
            case EnumQuestionType.YES_NO_QUESTION:
              if (typeof q.choice === 'boolean') {
                countDone++
              }
              break
            case EnumQuestionType.QUIZ:
              if (q.optionResult?.length) {
                countDone++
              }
              break
            case EnumQuestionType.SHORT_ANSWER:
              if (q.otherAnswerResult?.trim().length) {
                countDone++
              }
              break
          }
        }
        return countError === 0 && countDone > 0
      },

      getData() {
        return {
          questionList: this.listQuestion
            .filter(q => {
              return (
                typeof q.choice === 'boolean' ||
                q.optionResult?.length ||
                q.otherAnswerResult?.trim()
              )
            })
            .map(q => {
              const info = {
                questionType: q.questionType,
                questionCode: q.questionCode,
                questionName: q.questionName,
                choice: q.choice,
                optionResult: q.optionResult,
                otherAnswerResult: q.otherAnswerResult,
              }
              if (
                [
                  EnumQuestionType.CONDITIONAL_MULTIPLE_CHOICE,
                  EnumQuestionType.MULTIPLE_CHOICE,
                ].includes(q.questionType) &&
                !q.optionResult?.includes('OTHER')
              ) {
                info.otherAnswerResult = ''
              }
              return info
            }),
        }
      },
      setOnchange() {
        this.$emit('change')
      },
    },
  }
</script>

<style scoped lang="scss">
  .list {
    & + .list {
      border-top: 1px solid #ddd;
    }
  }
  h4.collapsible {
    color: black;
    cursor: pointer;
    padding: 10px;
    width: 100%;
    border: none;
    text-align: left;
    outline: none;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;

    &::after {
      content: '▼';
      font-size: 13px;
      color: #999;
      margin-left: 5px;
    }
    &.active::after {
      content: '▲' !important;
    }
    &:hover {
      background-color: #eee;
    }
  }

  .content {
    padding: 0 18px 6px 18px;
    display: none;
    overflow: hidden;
  }

  .contentul {
    list-style-type: none;
    padding-left: 20px;
  }

  .active {
    display: block;
  }

  ul.list-task {
    padding-left: 0;
    list-style-type: none;
    li {
      // display: flex;
      // align-items: center;
      span {
        margin-left: 10px;
      }

      &.no-data {
        color: #ddd;
        justify-content: center;
      }

      .list-images {
        margin-left: 15px;
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;
        .image-item {
          & + .image-item {
            margin-left: 10px;
          }
          height: 80px;
          display: inline-flex;
          overflow-y: hidden;
          .image {
          }
        }
      }
      .no-data {
        text-align: center;
        color: #ddd;
      }
    }
  }

  .error {
    color: red !important;
  }

  .success {
    color: green !important;
  }

  :deep(.form-group) {
    margin-bottom: 0 !important;
  }

  :deep(.custom-checkbox) {
    width: 100%;
    label.custom-control-label {
      width: 100%;
    }
  }
</style>
